import React, { useState } from 'react'
import { Button, Table, Tag, Alert, Upload, Space } from 'antd'
import { UploadOutlined, CheckCircleOutlined } from '@ant-design/icons'

const apiUrl = process.env.REACT_APP_API

const typeColor = { offer: 'green', rfq: 'blue', unknown: 'default' }
const typeLabel = { offer: 'Oferta', rfq: 'Cerere de oferta', unknown: 'Necunoscut' }

const TpmMsgUpload = () => {
  const [file, setFile] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [result, setResult] = useState(null)
  const [history, setHistory] = useState([])

  const handleUpload = async () => {
    if (!file) { setError('Selecteaza un fisier .msg sau .eml'); return }
    setLoading(true)
    setError(null)
    setResult(null)

    const formData = new FormData()
    formData.append('file', file)

    try {
      const res = await fetch(`${apiUrl}tpm/msg/upload`, {
        method: 'POST',
        credentials: 'include',
        body: formData,
      })
      const data = await res.json()
      if (!res.ok) { setError(data.message || 'Eroare la procesare'); return }
      setResult(data.data)
      setHistory(prev => [{ fileName: file.name, ...data.data, timestamp: new Date().toLocaleTimeString('ro-RO') }, ...prev.slice(0, 9)])
      setFile(null)
    } catch { setError('Eroare la conectarea cu serverul') }
    finally { setLoading(false) }
  }

  const historyColumns = [
    { title: 'Fisier', dataIndex: 'fileName', key: 'fileName', render: (v) => <small>{v}</small> },
    { title: 'Subiect', dataIndex: 'subject', key: 'subject' },
    { title: 'Tip', dataIndex: 'type', key: 'type', render: (v) => <Tag color={typeColor[v]}>{typeLabel[v]}</Tag> },
    { title: 'Articole', dataIndex: 'savedCount', key: 'savedCount' },
    { title: 'Ora', dataIndex: 'timestamp', key: 'timestamp', render: (v) => <small>{v}</small> },
  ]

  return (
    <div>
      {/* ── Upload card ── */}
      <div style={{ background: '#fff', borderRadius: 8, padding: 16, marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
        <div style={{ marginBottom: 8 }}>
          <strong style={{ fontSize: 16 }}>Upload Email</strong>
          <span style={{ color: '#888', marginLeft: 8, fontSize: 13 }}>Incarca un fisier .msg (Outlook) sau .eml pentru procesare</span>
        </div>

        {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 12 }} closable onClose={() => setError(null)} />}

        <Space style={{ marginBottom: 16 }}>
          <Upload
            accept=".msg,.eml"
            beforeUpload={(f) => {
              const name = f.name.toLowerCase()
              if (!name.endsWith('.msg') && !name.endsWith('.eml')) {
                setError('Selecteaza un fisier .msg sau .eml valid')
                return Upload.LIST_IGNORE
              }
              setFile(f)
              setError(null)
              return false
            }}
            onRemove={() => setFile(null)}
            fileList={file ? [{ uid: '1', name: file.name, status: 'done' }] : []}
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>Selecteaza fisier .msg / .eml</Button>
          </Upload>
          <Button
            type="primary"
            icon={<UploadOutlined />}
            onClick={handleUpload}
            disabled={!file}
            loading={loading}
          >
            {loading ? 'Se proceseaza...' : 'Proceseaza'}
          </Button>
        </Space>

        <div style={{ background: '#f5f5f5', borderRadius: 6, padding: 12, fontSize: 13 }}>
          <strong>Cum exporti un email din Outlook ca .msg:</strong>
          <ol style={{ marginBottom: 0, marginTop: 8 }}>
            <li>Deschide emailul in Outlook</li>
            <li>Click <strong>File → Save As</strong></li>
            <li>La "Save as type" selecteaza <strong>Outlook Message Format (*.msg)</strong></li>
            <li>Salveaza si incarca fisierul aici</li>
          </ol>
        </div>
      </div>

      {/* Rezultat procesare */}
      {result && (
        <Alert
          type={result.type === 'offer' ? 'success' : result.type === 'rfq' ? 'info' : 'warning'}
          icon={<CheckCircleOutlined />}
          showIcon
          style={{ marginBottom: 16 }}
          message={
            <span>
              <strong>Email procesat cu succes</strong>{' '}
              <Tag color={typeColor[result.type]}>{typeLabel[result.type]}</Tag>
            </span>
          }
          description={
            <div>
              <div><strong>Subiect:</strong> {result.subject}</div>
              <div><strong>De la:</strong> {result.from}</div>
              <div><strong>Articole salvate:</strong> {result.savedCount}</div>
              {result.rfqId && <div><strong>RFQ creat:</strong> #{result.rfqId}</div>}
            </div>
          }
        />
      )}

      {/* Istoric procesari */}
      {history.length > 0 && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
          <strong style={{ display: 'block', marginBottom: 12 }}>Istoric procesari din aceasta sesiune</strong>
          <Table
            columns={historyColumns}
            dataSource={history}
            rowKey={(_, i) => i}
            size="small"
            pagination={false}
          />
        </div>
      )}
    </div>
  )
}

export default TpmMsgUpload
